export default {
  toasted: {
    welcome_back: '欢迎回来! 距离你上次访问已经过了 {sec} 秒了哦',
    date_invaild: '无效的日期!',
    set_date: '设置成功!'
  },
  level: {
    light: '轻度压力',
    moderate: '适当恐慌',
    terrifying: '有点吓人',
    wtf: '这啥？'
  },
  title: {
    motivation: 'Motivation',
    level: '级别',
    date: '日期 (比如你的生日)'
  },
  button: {
    confirm: '确认'
  },
  placeholder: {
    year: '年',
    month: '月',
    day: '日'
  },
  message: {
    default: '点击开始',
    readme: `<p>输入日期，看时间飞逝</p>
        <p><strong>你输入的任何信息都不会离开你的浏览器</strong></p>
        <p>Motivated by <a href="https://github.com/soffes/Motivation">Motivation</a></p>`
  }
}
